import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import Logo from "../../../assets/engage-full-color.svg";
import "../PrivacyPolicy/PrivacyPolicy.scss";

const TermsAndConditions = (props) => {
  return (
    <Grid className={"vestevo-policies"} container spacing={3}>
      <Grid item xs={8}>
        <Typography component={"h1"} variant={"h1"}>
          TERMS OF SERVICE
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Button
          variant={"contained"}
          color={"secondary"}
          onClick={props.onClose}
        >
          Close
        </Button>
      </Grid>
      <Grid item xs={12}>
        <div className={"company-logos"}>
          <img src={Logo} alt={"Engage"} title={"Engage"} width={"203px"} />
        </div>
      </Grid>
      <Grid item xs={12}>
        <div className="tou-container">
          <Typography component={"h2"} variant={"h2"}>
            Engage Subscription Agreement 08/22
          </Typography>
          <p>
            PLEASE READ THE FOLLOWING TERMS OF USE CAREFULLY PRIOR TO USING OUR
            PRODUCT. IF YOU DO NOT AGREE TO BE BOUND BY THIS AGREEMENT (INCLUDED
            THE TERMS OF USE), PLEASE DO NOT USE OUR SERVICE.
          </p>
          <p>
            This legal agreement (the “Subscription Agreement”) set forth below
            governs the relationship between you and/or any of your agent(s)
            (referred to herein as “you” or “your”) and WealthCentral Inc, a
            Delaware limited liability company (referred to herein as
            “WealthCentral,” “we,” “us” or “our”), with respect to your use of
            our financial planning software-based product Engage, accessible via
            our website at engage.wealthcentral.com (referred to herein as the
            “Service”).
          </p>
          <Typography component={"h2"} variant={"h2"}>
            1. TERMS OF USE
          </Typography>
          <p>
            The following provisions constitute the Terms of Use for the Service
            and are incorporated into and form a part of this Subscription
            Agreement. We reserve the right to update or modify these Terms of
            Use at any time, and without prior notice to you. Your continued use
            of the Service following such modification or update constitutes
            your acceptance to be bound by these Terms of Use, as they may be
            changed or modified. Any terms and conditions proposed by you which
            are in addition to, or which conflict with, the Terms of Use are
            expressly rejected by WealthCentral and shall be of no force or
            effect. By accessing or using the Service, downloading any content,
            and/or inputting any information through the Service, you
            acknowledge your agreement to be bound by these Terms of Use.
          </p>
          <p>
            By accepting this Subscription Agreement, you represent that you
            have the capacity to be bound by it or, if you are acting on behalf
            of a company or entity, that you have the legal authority to bind
            such entity. Before you continue, we encourage you to print or save
            a local copy of this Subscription Agreement for your records.
          </p>
          <p>
            THIS SUBSCRIPTION AGREEMENT AND THE SERVICE OFERED IN CONNECTION
            THEREWITH IS INTENDED ONLY FOR INVESTMENT PROFESSIONALS REGISTERED
            UNDER THE INVESTMENT ADVISERS ACT OF 1940 OR UNDER THE LAWS OF THE
            JURISDICTIONS IN WHICH ONE IS REQUIRED TO BE REGISTERED OR LICENSED
            IN ORDER TO PROVIDE INVESTMENT ADVICE OR INVESTMENT ADVISORY
            SERVICES, REGISTERED REPRESENTATIVES OF BROKER-DEALERS LICENSED BY
            THE SECURITIES AND EXCHANGE COMMISSION AND THE FINANCIAL INDUSTRY
            REGULATORY AUTHORITY (FINRA), OR STAFF WORKING DIRECTLY UNDER THE
            SUPERVISION OF ANY OF THE FOREGOING (SUCH PERSONS, “LICENSED
            INVESTMENT PROFESSIONALS”).
          </p>
          <p>
            IF YOU ARE NOT A LICENSED INVESTMENT PROFRESIONAL AS DESCRIBED ABOVE
            OR IF YOU DO NOT AGREE WITH ANY PART OF THESE TERMS OF USE, YOU MUST
            NOT USE THE SERVICE.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            2. NATURE OF SERVICE
          </Typography>
          <p>
            <b>(a) Features.</b> The Service contains a variety of online
            analysis tools and services for Licensed Investment Professional to
            assist them in providing financial services to their clients. The
            Service includes features such as a Roth conversion strategies, tax
            optimization strategies, budgeting, reporting and analytics, as well
            as any other features or content made available by Engage.
          </p>
          <p>
            <b>(B) DISCLAIMER.</b> ALTHOUGH THE SERVICE MAY PROVIDE YOU WITH
            INFORMATION OR GUIDANCE IN MAKING INVESTMENT DECISIONS FOR AND/OR
            RECOMMENDATIONS TO YOUR CLIENTS, IT IS NOT A SUBSTITUTE FOR YOUR
            KNOWLEDGE, JUDGMENT AND INVESTMENT DISCRETION IN RENDERING
            INVESTMENT ADVICE FOR CLIENTS. YOU WILL BE SOLELY RESPONSIBLE FOR
            PROVIDING INVESTMENT ADVICE AND SERVICES TO CLIENTS AND YOU
            ACKNOWLEDGE THAT WEALTHCENTRAL BEARS NO RESPONSIBILITY IN THIS
            REGARD. THE SERVICE DOES NOT PROVIDE CUSTOMIZED TAX, LEGAL,
            INVESTMENT, OR RISK MANAGEMENT ADVICE OR STRATEGIES.
          </p>
          <p>
            <Typography component={"h2"} variant={"h2"}>
              3. REGISTRATION AND SUBSCRIPTION; NOTICES; DATA BACK-UP
            </Typography>
          </p>
          <p>
            <b>(a) Registration.</b> In order to access and use the Service, you
            must register and create an account with us and pay us the
            applicable Subscription Fee (the “Subscription Fee”). We reserve the
            right to reject any subscription order
          </p>
          <p>
            <b>(b) User ID.</b> Upon creating an account, you will receive a set
            of unique log-in credentials (referred to herein as your “User ID”),
            which includes a username and password to permit you to access to
            the Service. Without limiting our rights under Section 3(a) above,
            WealthCentral reserves the right to deny creation of your account
            based on our inability to verify the authenticity of your
            registration information.
          </p>
          <p>
            <b>(c) Multiple Seats.</b> Some subscription orders may be for
            multiple “seats” to use our Service (such subscribers, the “Master
            Account Holder”). Master Account Holders generally will be able to
            configure User IDs for their authorized users. Please contact our
            Support Department for assistance. Master Account Holders are
            responsible for all use of the Service and the Site by their
            authorized users and such authorized users’ compliance with this
            Agreement.
          </p>
          <p>
            <b>(c) Subscription Term and Billing.</b> All our annual
            subscription plans are provided on a term of 12 consecutive months
            of service from the initial date of purchase. Payments for a
            subscription term can be billed monthly or annually.
          </p>
          <p>
            Subscribers are responsible for the Subscription Fees for the entire
            12-month term. Cancellation of monthly subscription fee services
            prior to completing 12 consecutive months of service will result in
            a $300 early termination fee. No refunds are available for annual
            subscription fee cancellations.
          </p>
          <p>
            Your subscription will automatically renew at the end of the term.
            If you choose to change your service prior to your renewal date,
            please contact the sales team at 1-800-444-115 prior to your renewal
            date. Once the subscription has renewed we will only issue a refund
            within 15 days of the renewal date.
          </p>
          <p>
            <b>(d) Subscription Fees.</b> Your initial Subscription Fee is the
            rate at which you were offered a subscription to access the Service,
            which is subject to change. Subscription Fees on renewal are the
            applicable rates then in effect. Changes to subscription pricing
            will be communicated to you at least 30 days in advance. If you opt
            to pay your subscription fee up front, your price is guaranteed for
            the 12 month term. If you pay your fee monthly, and a price increase
            goes into effect, you may terminate your account in accordance with
            the subscription terms and billing as outlined in section c).
          </p>
          <p>
            <b>(e) Trial Periods.</b> We offer new subscribers a no obligation
            trial period (the “Trial Period”) during which they may cancel their
            subscription with no charge to their credit card if they are not
            satisfied with the Service. Unless your subscription offer provides
            otherwise, the maximum Trial Period shall be thirty (30) days from
            the date of an initial registration. If you do not wish to continue
            using Engage after this time, please provide a written notification
            to{" "}
            <a href={"mailto:support@wealthcentral.com"}>
              support@wealthcentral.com
            </a>{" "}
            After the expiration of the Trial Period, users will not be entitled
            to any Subscription Fee refunds – regardless of whether they used
            the Service. Please note that Trial Periods do not apply to renewal
            subscriptions nor to new subscriptions set up by persons who have
            used the Service within the last 12 months.
          </p>
          <p>
            <b>(f) Auto-renewal.</b> Your subscription will renew automatically
            at the end of your subscription term at the applicable rates then in
            effect unless you provide us with a cancellation notice prior to
            such renewal date (see “Cancellations and Refunds,” below). You
            hereby authorize us to (a) charge any credit or debit card you have
            on file for your renewal Subscription Fees or (b) if you have set up
            a bank draft with a financial institution, to initiate a withdrawal
            of funds against your account at the financial institution for such
            your renewal Subscription Fees. So as to help avoid any disruptions
            in your access to the Service, please keep your payment information
            up to date. If your credit or debit card information on record is
            invalid or expired, or your financial institution declines to
            process the bank draft, our Support Department will use reasonable
            commercial efforts to contact you to request you update your payment
            information.
          </p>
          <p>
            <b>(g) Cancellation and Refunds.</b> Except during Trial Periods, we
            do not offer Subscription Fee refunds. If you are registering for
            the Service for the first time, you may cancel your subscription
            anytime during the applicable Trial Period and your credit card will
            not be charged. After the expiration of your Trial Period, any
            cancellations will be subject the terms and conditions outlined in
            Section C.
          </p>
          <p>
            <b>(h) Data Back-Up.</b> We back up and retain all data entered into
            the Service in accordance with procedures that we have determined to
            be commercially reasonable. Notwithstanding our data back-up and
            retention procedures, we are not responsible for backing up your
            data, account information, Client Information or other type of data
            attributed to your use of the Service. YOU EXPRESSLY AGREE TO ASSUME
            THE SOLE RISK OF BACKING UP ALL ACCOUNT INFORMATION AND CLIENT
            INFORMATION WHEN USING THE SERVICE AND EXPRESSLY AGREE THAT WE WILL
            HAVE NO LIABILITY WITH RESPECT TO LOST CLIENT INFORMATION AND/OR
            ACCOUNT INFORMATION. As used in these Terms of Use, “Client
            Information” means any personal or financial information pertaining
            to a Client.
          </p>
          <p>
            <b>(i) Suspended Accounts/Data.</b> After your subscription term has
            ended and if no payment has been made for a renewal term, access to
            your account will be suspended. Unless we are required by law or
            contract to maintain your account data, we may purge your account
            data within six (6) months of the date that your account access was
            suspended and/or terminated in accordance with these Terms of Use.
            Purged data may be unrecoverable.
          </p>
          <p>
            <b>(j) Taxes.</b> Our fees do not include any taxes, levies, duties
            or similar governmental assessments of any nature, including, for
            example, value-added, sales, goods and services, use or withholding
            taxes, assessable by any jurisdiction whatsoever (collectively,
            “Taxes”). You are responsible for paying all Taxes associated with
            your subscription, includes Taxes assessed after you pay your
            Subscription Fee. If we have the legal obligation to pay or collect
            Taxes for which you are responsible hereunder, we will invoice you
            and you agree to pay such amount unless you provide us with a valid
            tax exemption certificate authorized by the appropriate taxing
            authority. You hereby authorize us to charge any credit or debit
            card you have on file for such Taxes. We shall be responsible for
            all taxes based upon our net income or on our property ownership.
          </p>
          <p>
            <b>(k) Receiving Notices.</b> By providing us with your e-mail
            address, you consent to receive any notices from us electronically,
            to that e-mail address. It is your responsibility to update or
            change your email address, as appropriate. Please note that our
            notices may be provided in the text of the e-mail or through a link
            to the appropriate page on our Site.
          </p>
          <p>
            <b>(l) Electronic Signature.</b> When you click on an “I agree,” “I
            consent” or other similarly worded “button” or entry field with your
            mouse, keystroke or other device, such action will constitute your
            agreement or consent and will be legally binding and enforceable and
            the legal equivalent of your handwritten signature.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            4. LICENSE, OWNERSHIP AND PROPRIETARY RIGHTS
          </Typography>
          <p>
            <b>(a) License.</b> For individual subscribers, we grant you a
            single, non-perpetual, non-exclusive, non- transferable and limited
            license to access and use the Service during the term of your
            subscription. For Master Account Holders, we grant you a
            non-perpetual, non-exclusive, non-transferable and limited license
            to access and use the Service during the term of your subscription
            for the paid number of seats for which you have subscribed. This
            license is conditioned on your continued compliance with the Terms
            of Use. Please note that each license is specific to one user only.
            Account sharing, or having a single individual act, using their
            license, on behalf of multiple advisors is strictly prohibited. Each
            Engage licenses is to be used by one financial professional.
            Violation of this usage condition will cause immediate account
            suspension, and Engage will have the right to pursue recovery of
            avoided license costs.
          </p>
          <p>
            <b>(b) Ownership and Proprietary Rights.</b> You acknowledge and
            agree that we and our licensors retain any and all ownership rights
            related to the Service, including applicable proprietary rights and
            are protected by United States laws and international treaty
            provisions. “Engage” is our product trademark and “WealthCentral” is
            our operational company.
          </p>
          <p>
            <b>(c) Protecting Our Rights.</b> You acknowledge that the Service
            has been developed, compiled, prepared, revised, selected, and
            arranged by WealthCentral and others through the application of
            methods and standards of judgment developed and applied through the
            expenditure of substantial time, effort, and money and that the
            Service is the valuable intellectual property of WealthCentral and
            such others persons who may be providing content or services to us
            under license.
          </p>
          <p>
            The content on the Site, excluding all intellectual property of
            other sites obtained by way of linking, is owned by WealthCentral
            (or used by WealthCentral under license). This includes, without
            limitation, text; software; the look and feel of the Site, service
            and applications, such as color combinations, logos, button shapes,
            scripts, and graphics; photos; sounds; interactive features; and the
            trademarks, service marks and logos contained on the Site, services
            or applications (collectively referred to herein as the “Content”).
            The Content is owned by, or licensed to, WealthCentral, in each case
            subject to copyright and other intellectual property rights under
            applicable law.
          </p>
          <p>
            All present and future rights in and to trade secrets, patents,
            copyrights, trademarks, service marks, know- how, and other
            proprietary rights of any type under the laws of any governmental
            authority, domestic or foreign, including rights in and to all
            applications and registrations relating to the Service (the
            “Intellectual Property Rights”) shall, as between you and
            WealthCentral, at all times be and remain the sole and exclusive
            property of WealthCentral. All present and future rights in and
            title to the Service are reserved to WealthCentral for its exclusive
            use.
          </p>
          <p>
            <b>(d) Restriction on Consent.</b> The Content provided by us is
            provided to you “AS IS” for the purposes set forth in these Terms of
            Use, and may not be used, copied, reproduced, modified,
            re-distributed, transmitted, broadcast, displayed, sold, licensed,
            or otherwise exploited for any other purposes whatsoever without our
            written consent. You also shall not reverse engineer, reverse
            compile, decompile, disassemble or otherwise create derivative works
            based on the Content. You shall not alter or remove any notice of
            Intellectual Property Rights which may appear on the user interface
            or any data output generated as a result of your use of the Service.
          </p>
          <p>
            <b>(f) Morningstar Notice.</b> Portions of the mutual fund
            information contained on the Site were supplied by Morningstar,
            subject to the following: © 2014 Morningstar, Inc. All Rights
            Reserved. The information contained herein: (1) is proprietary to
            Morningstar and/or its content providers; (2) may not be copied or
            distributed; and (3) is not warranted to be accurate, complete or
            timely. Neither Morningstar nor its content providers are
            responsible for any damages or losses arising from any use of this
            information. Past performance is no guarantee of future results.
          </p>
          <p>
            <b>(f) Unsolicited Information and Feedback.</b> While we welcome
            your feedback or other suggestions regarding this Site, the Service
            and/or our various offerings (collectively “Feedback”), you provide
            such Feedback to us voluntarily. You shall be deemed to have granted
            us a perpetual, royalty-free, fully paid up and irrevocable right
            and license to use, reproduce, modify, publicly display, distribute,
            transmit, sublicense, create derivative works from, transfer,
            sublicense and sell such Feedback.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            5. USAGE RULES
          </Typography>
          <p>
            The following are the rules apply to your use of the Service (the
            “Usage Rules”). We may, without prior notice and without limiting
            our other remedies, deny you access to any and all parts of the Site
            and/or the Service and suspend or terminate your account if, in our
            sole discretion, we find you to be in violation of the Usage Rules.
          </p>
          <p>
            <b>(a) Unlawful Purposes.</b> You will not use the Content for any
            purpose that is unlawful or prohibited by these Terms of Use. You
            also are responsible for any Client Information that you enter or
            cause to be entered of transmitted through your account.
          </p>
          <p>
            <b>(b) Prohibition on Use by Persons under Age 18.</b> Unless
            expressly authorized by a parent or guardian, CHILDREN UNDER THE AGE
            OF EIGHTEEN ARE NOT PERMITTED TO SUBMIT ANY PERSONALLY IDENTIFIABLE
            INFORMATION OR UNSOLICITED INFORMATION.
          </p>
          <p>
            <b>(c) Unauthorized Access.</b> You shall not permit any other
            person (other than persons otherwise authorized under these Terms of
            Use) to access the Service under your User ID for any purpose.
          </p>
          <p>
            <b>(d) Password and Account Protection.</b> You are responsible for
            maintaining the confidentiality of your password which, together
            with your User ID and registered e-mail address, allows you to
            access the Services. You agree that you will not disclose your
            password to any third party and that you are responsible for any
            activities or actions in your Engage account, whether or not you
            have authorized those actions. You shall immediately notify us of
            any known or suspected unauthorized use(s) of your account, or any
            known or suspected breach of security, including loss, theft, or
            unauthorized disclosure of your password or credit card information,
            or if your registered e-mail account has been compromised.
          </p>
          <p>
            <b>(e) Interference with Third Parties.</b> You shall not interfere
            with any other person’s use of the Service, including, without
            limitation, disrupting, spamming or otherwise using abusive tactics
            to deter others from using the Service or any of its features.
          </p>
          <p>
            <b>(f) Harmful Code;</b> Other Practices. You may not post or
            transmit any file to this Site (or to any other party offering
            services via this Site, including Third Party Services) or to any
            other user which contains viruses, worms, time bombs, malware Trojan
            horses or any other contaminating or destructive code. You shall not
            exploit the Site, the Service or the Third Party Services to
            trespass or burden network capacity.
          </p>
          <p>
            <b>(g) Other Prohibited Activities.</b> You will not to use the Site
            or the Service (or assist or encourage others to use the Site or the
            Service) in order to:
          </p>
          <ol>
            <li>
              Solicit passwords or personal identifying information for
              commercial or unlawful purposes from others;
            </li>
            <li>
              Impersonate another person or entity, whether or not a user of the
              Service;
            </li>
            <li>
              Select a User ID already used by another person; use a User ID in
              which another person has rights without such person’s
              authorization; or use a username or password that we, in our sole
              discretion, deem offensive or inappropriate.
            </li>
            <li>
              Upload, post, email, transmit or otherwise make available
              restricted or password only access pages or hidden pages or images
              (those not linked to or from another accessible page);
            </li>
            <li>
              Falsify or delete any author attributions, legal or other proper
              notices or proprietary designations or labels stating the origin
              or source of software or other Content contained on the Site;
            </li>
            <li>
              Attempt to sell, modify, reverse engineer, disassemble, decompile,
              frame, decrypt, decompile, create derivative works of or otherwise
              exploit for any commercial purpose the Site or Service, any
              portions thereof (including the Content and Client Information of
              our other users), or any of our affiliated organizations without
              our prior written consent;
            </li>
            <li>
              Do anything that may interfere with the operation of the Service,
              including, but not limited to, hacking, spamming and flood
              attacking;
            </li>
            <li>
              Remove any copyright, Trademark or other proprietary rights
              notices contained in or on the Site;
            </li>
            <li>
              Interfere with or disrupt the Site, the Service or servers or
              networks connected to either, or disobey any requirements,
              procedures, policies or regulations of networks connected to the
              Site;
            </li>
            <li>
              Attempt to harvest, scrape, copy or otherwise collect information,
              or Content from the Site, to retrieve or index any portion of the
              Site or collect information about other users for any purpose not
              expressly authorized by us, including, without limitation,
              republishing the same on a third party website, either manually or
              through any engine, software, tool, agent, or other device or
              mechanism (including without limitation browsers, spiders, robots,
              avatars, site search/retrieval application, intelligent agents or
              other device);
            </li>
            <li>
              Access Content or data not intended for you, or log onto a server
              or under a User ID that you are not authorized to access;
            </li>
            <li>
              Create accounts by automated means, or under false or fraudulent
              pretenses; or provide false, misleading or inaccurate information
              to WealthCentral or any other user;
            </li>
            <li>
              Harvest or otherwise collect information about other Licensed
              Investment Professional or their clients, including email
              addresses, passwords, User IDs or phone numbers;
            </li>
            <li>
              Harass, abuse, stalk, threaten, defame or otherwise infringe or
              violate the rights of any other party; or
            </li>
            <li>
              Use the Site or Service to solicit or recruit other persons to
              another website or service.
            </li>
          </ol>
          <Typography component={"h2"} variant={"h2"}>
            6. OBTAINING CLIENT INFORMATION FROM THIRD PARTIES
          </Typography>
          <p>
            WealthCentral may need to access some of your Client Information
            from third parties in order to make available certain applications
            and services to you and to provide you with a better user
            experience. You expressly consent and authorize WealthCentral to
            access Client Information maintained by identified third parties, on
            your behalf as your agent. WealthCentral will submit information
            including usernames and passwords that you provide to log you into
            the Site. For example, at your direction, we may arrange for Client
            Information to be transferred to us from a financial institution or
            funds custodian so that such information may be presented to you in
            connection with the Service. You hereby authorize and permit
            WealthCentral to use and store information submitted by you to the
            Service (such as account passwords and user names) to accomplish the
            foregoing and to configure the Service so that it is compatible with
            the third party sites for which you submit your information or
            Client Information. For purposes of these Terms of Use, you grant
            WealthCentral a limited power of attorney, and appoint WealthCentral
            as your attorney-in-fact and agent, to access third party sites,
            retrieve and use Client Information with the full power and
            authority to do and perform each thing necessary in connection with
            such activities, as you could do in person. YOU ACKNOWLEDGE AND
            AGREE THAT WHEN WEALTHCENTRAL IS ACCESSING AND RETRIEVING
            INFORMATION FROM THIRD PARTY SITES, WEALTHCENTRAL IS ACTING AS YOUR
            AGENT, AND NOT AS THE AGENT OF OR ON BEHALF OF THE THIRD PARTY.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            7. COLLECTION OF INFORMATION; SHARING YOUR INFORMATION OR CLIENT
            INFORMATION
          </Typography>
          <p>
            When you use the Service, our servers automatically record
            information about your interaction with our analysis tools and
            services (“log data”), including information that your browser sends
            whenever you visit a website or your mobile app sends when you use
            it to access the Service. This log data may include, among other
            things, your Internet Protocol address, the address of the web page
            you were visiting before you came to the Service, browser type and
            settings, the date and time of your request, and how you used the
            Service. Depending on how you access the Service, we may use
            “cookies” (a small text file sent by your computer each time you
            visit our website, unique to your Engage account or your browser) or
            similar technologies to record log data as well as Uniform Resource
            Locators (URLs). When we use cookies, we may use “session” cookies
            (that last until you close your browser) or “persistent” cookies
            (that last until you or your browser delete them). For example, we
            may use cookies to store your Engage settings so you don’t have to
            set them up every time you visit our website.
          </p>
          <p>
            In addition to log data, we also may collect information about the
            device you are using the Service on, including what type of device
            it is, what operating system you are using, device settings, unique
            device identifiers, and crash data. Whether we collect some or all
            of this information often depends on what type of device you are
            using and its settings. For example, different types of information
            are available depending on whether you are using a Mac or a PC, or
            an iPhone or an Android phone. To learn more about what information
            your device makes available to us, please also check the policies of
            your device manufacturer or software provider.
          </p>
          <p>
            We may create Anonymous Information records from account information
            or Client Information. "Anonymous Information" is information that
            is not associated with or linked to Client Information and does not
            permit the identification of individual clients or accounts.
            Generally, we aggregate this information and use it in statistical
            analysis to help us analyze patterns in the use of the Service. We
            may use or disclose Anonymous Information in any way (including
            providing benchmarking data or analysis for the users of the
            Service) and we reserve the right to use and disclose Anonymous
            Information to our partners, advertisers and other third parties in
            our discretion.
          </p>
          <p>
            We may provide your information as well as Client Information to
            third party service providers who work on behalf of, or with us, but
            solely to the extent necessary for us to provide some of the
            services and features of Engage and/or to help us communicate with
            you (such persons, “Service Providers”). Examples of such services
            include sending email, hosting our applications, storing data,
            arranging for the receipt of Client Information from financial
            institutions, funds custodians or persons authorized to transfer
            such account information, analyzing data, and providing customer
            service. You consent and authorize us to delegate the Client
            Information and your information that you provide to WealthCentral
            to its Service Provider(s) as we deem necessary or desirable to
            provide the Service to you. You also agree that all references to
            “WealthCentral and Engage” within the Terms of Use and any
            incorporated terms are also deemed to include, where applicable, our
            agents, such as Service Providers.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            8. THIRD PARTY APPLICATIONS
          </Typography>
          <p>
            Portions of our Site may utilize or include certain third party
            services (“Third Party Services”) that are not owned, operated, or
            controlled by WealthCentral. Therefore, we cannot and do not assume
            responsibility for the content, privacy policies, or practices of
            such services or the companies that own them. We encourage you to
            learn about the privacy practices and terms and conditions of each
            Service Provider before agreeing to give it your data, your Client
            Information or using its applications. For more information, please
            review the Service Provider’s applicable policies and terms of
            services or contact the Service Provider directly. Third Party
            Services are provided “AS IS”, WITH ALL FAULTS” and “AS AVAILABLE”
            and as a convenience to you. You hereby expressly relieve us from
            any and all liability arising from your use of any such Third Party
            Services. WEALTHCENTRAL DOES NOT ENDORSE THIRD PARTY APPLICATIONS OR
            SERVICES.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            9. THIRD PARTY SITES AND ADVERTISING
          </Typography>
          <p>
            Engage may contain links to other websites to notify you of services
            or products which may be of interest to you. The links or resources
            about third party sites are provided for your convenience and
            reference only. These third party sites are not owned, operated, or
            controlled by WealthCentral. Please be aware that we are not
            responsible for the availability of the third-party websites or
            resources, any content posted on their websites, their privacy
            policies, or their business practices. WealthCentral makes no
            guarantees and disclaims any express or implied representations or
            warranties about the accuracy, relevance, timeliness, completeness,
            or appropriateness for a particular purpose of the services or other
            information obtained from or contained on such websites. We
            encourage you to read the privacy policies of each and every website
            you visit. The ability to access information of third-parties from
            Engage, or links to other websites or locations, is for your
            convenience and does not signify our endorsement of such
            third-parties, their products, their services, other websites,
            locations or their content.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            10. REPRESENTATIONS AND WARRANTIES
          </Typography>
          <p>You represent and warrant that:</p>
          <ol>
            <li>
              You are a Licensed Investment Professional, and will continue to
              remain a Licensed Investment Professional while granted access to
              the Service.
            </li>
            <li>
              With respect to each Client for whom you will utilize the Service,
              you have authority to disclose Client Information in connection
              with your use of the Service.
            </li>
            <li>
              You will safeguard confidential, protected, non-public personal
              information which is received, transmitted, managed, and/or
              processed via the Service.
            </li>
            <li>
              You agree to protect our proprietary rights and that of all others
              having rights in the Service during and after the term of your
              subscription.
            </li>
            <li>
              You shall not violate any of copyright, trademark or other
              proprietary right, and shall be solely responsible for any damages
              resulting from any such infringement or any other harm resulting
              from any software, data or files of any type you upload, download,
              distribute, access, post, submit, or transmit to or from the
              Service.
            </li>
            <li>
              The information and results of calculations obtained through the
              use of the Service will be represented accurately and used in
              compliance with all applicable laws and regulations.
            </li>
            <li>
              You will at all times ensure that you are using adequate security
              standards, which includes a commercially reasonable security
              technology which provides a level of security that, at a minimum,
              is compliant with the applicable laws and industry standards.
            </li>
            <li>
              You currently follow industry standards as a means to prevent any
              compromise of your information systems, computer networks or data
              files by unauthorized users, viruses or malicious computer
              programs which could in turn be propagated via computer networks,
              electronic mail, magnetic media or other means to the Site.
            </li>
            <li>
              You will not and any third party shall not be permitted to upload,
              post, copy, display, reproduce or distribute any malicious code.
            </li>
            <li>
              You will not sell, rent, lease or share (except as specifically
              provided for in these Terms of Use) your access to the Service.
            </li>
            <li>
              You will immediately notify us if there is any change which
              invalidates any of the representations or warranties you have
              given in Terms of Use.
            </li>
            <li>
              You acknowledge and agree that the Service is subject to
              restrictions and controls imposed by the Export Administration Act
              and the Export Administration Regulations (“Acts”). You agree and
              certify that neither the Service nor any direct product thereof is
              being or will be acquired, shipped, transferred or exported,
              directly or indirectly outside the United States or will be used
              for any purpose prohibited by the Acts; provided, however, U.S.
              citizens and U.S. permanent resident aliens may travel to
              countries not prohibited by the Acts and access the Service
              provided they are not using the Service in violation of the Acts
              or other applicable U.S. laws. You are responsible for complying
              with all trade regulations and laws both foreign and domestic. You
              acknowledge that none of our applications and/or Service or
              underlying information or technology may be downloaded or
              otherwise exported or re-exported (a) into any U.S.-embargoed
              countries; or (b) to anyone on the U.S. Treasury Department’s list
              of Specially Designated Nationals or the U.S. Commerce
              Department’s Denied Parties List or Entity List. By using our
              applications and/or Service you are agreeing to the foregoing and
              are representing and warranting that: (a) no U.S. federal agency
              has suspended, revoked, or denied you export privileges; (b) you
              are not located in or under the control of a national or resident
              of any such country or on any such list; (c) you will not export
              or re-export the Service to any prohibited county, or to any
              prohibited person, entity, or end-user as specified by U.S. export
              controls; and (d) you will not use the Service for any purposes
              prohibited by United States law, including, without limitation,
              the development, design, manufacture, or production of nuclear,
              missile, or chemical or biological weapons.
            </li>
          </ol>
          <Typography component={"h2"} variant={"h2"}>
            11. DISCLAIMER OF WARRANTIES
          </Typography>
          <p>
            Your use of the Service is at your sole risk. The Service is
            provided “AS IS,” “WITH ALL FAULTS” and “AS AVAILABLE.”
            WealthCentral and its licensors, suppliers and distributors disclaim
            all warranties, whether express or implied, including the warranties
            that the Service is free of defects, virus-free, and able to operate
            on an uninterrupted basis; that the functionality of the Service
            will meet your requirements, or that errors in the Service will be
            corrected, and the implied warranties that the Service is
            merchantable, of satisfactory quality, accurate, fit for a
            particular purpose or need, or non-infringing, unless such implied
            warranties are legally incapable of exclusion. Further,
            WealthCentral and its licensors and suppliers do not warrant or make
            any representations regarding the use or the results of the use of
            the Service in terms of their correctness, accuracy, reliability, or
            otherwise. Also, WealthCentral does not warranty lack of viruses,
            worms, trojan horses or other code that manifest contaminating or
            destructive properties, or any failure to provide the Service or
            access thereto by users. WealthCentral does not guarantee the
            timeliness, validity, completeness or accuracy of the content.
            Although we may update the content on this Site and/or the Service
            from time to time, please note that information contained herein may
            be out of date and/or may contain inaccuracies or typographical
            errors. WealthCentral and its licensors, suppliers and distributors
            also do not warrant or make any representations regarding the
            quality of materials or data downloaded, uploaded, or transferred
            using any application. In addition, any security mechanisms
            implemented by the Service have inherent limitations, and you must
            determine that the Service sufficiently meets your requirements. No
            oral or written information or advice given by WealthCentral or
            Engage, or a WealthCentral or Engage authorized representative,
            shall create a warranty or increase the scope of any warranty that
            cannot be disclaimed under applicable law. WealthCentral and its
            licensors and other suppliers have no liability with respect to your
            use of the Service. You bear the entire risk as to the quality and
            performance of any application and assume the entire cost of any
            service and repair. This disclaimer of warranty constitutes an
            essential part of these Terms of Use. NO USE OF THE SERVICE IS
            AUTHORIZED UNLESS YOU ACCEPT THIS DISCLAIMER OF WARRANTY.
          </p>
          <p>
            WE ARE NOT ENGAGED IN RENDERING INVESTMENT OR FINANCIAL ADVICE, AND
            THE RESULTS OF USE OF THE SERVICE AND CONTENT MUST NOT BE REGARDED
            OR REPRESENTED AS CONSTITUTING INVESTMENT OR FINANCIAL ADVICE. PRIOR
            INVESTMENT PERFORMANCE DOES NOT WARRANTY FUTURE RESULTS. AS SUCH,
            WEALTH CENTRAL AND ENGAGE DO NOT MAKE ANY REPRESENTATIONS OR
            WARRANTIES REGARDING THE ACCURACY OF ANY PROJECTIONS GENERATED BY
            THE SERVICE.
          </p>
          <p>
            AS A PROFESSIONAL FINANCIAL ADVISOR, YOU BEAR ALL RESPONSIBILITY FOR
            ADVICE AND SERVICES FURNISHED TO YOUR CLIENTS, REGARDLESS OF WHETHER
            YOU EMPLOYED THE SERVICE IN CONNECTION WITH THE DEVELOPMENT OF SUCH
            ADVICE. POSSIBLE FUTURE RESULTS OF INVESTMENT DECISIONS ARE PROVIDED
            MERELY FOR INFORMATION PURPOSES AND SHOULD NOT BE REGARDED AS A
            PREDICTION OR GUARANTEE OF ANY FUTURE RESULTS. You agree that by
            using the Service, you will assume sole responsibility to exercise
            your own professional judgment in verifying all information when
            inputting your own assumptions, relying on any assumptions provided
            through the Service, and/or verifying the accuracy of Client
            Information.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            12. WAIVER, RELEASE AND LIMITATION OF LIABILITY
          </Typography>
          <p>
            YOU AGREE THAT ENGAGE, ITS AFFILIATES AND PARENT COMPANIES, AND
            THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS,
            REPRESENTATIVES, SUCCESSORS, AND ASSIGNS, INFORMATION PROVIDERS,
            PARTNERS (INCLUDING, WITHOUT LIMITATION, RESELLERS, INTERNET PORTAL
            PROVIDERS AND FINANCIAL INSTITUTIONS THROUGH WHOM YOU MAY HAVE BEEN
            INTRODUCED OR PROVIDED ACCESS TO THE SERVICE, CONTENT OR REPORTS)
            AND SUPPLIERS (COLLECTIVELY, THE “WEALTHCENTRAL GROUP”) SHALL HAVE
            NO LIABILITY TO YOU UNDER ANY THEORY OF LIABILITY OR INDEMNITY IN
            CONNECTION WITH YOUR USE OF THE SERVICE. YOU HEREBY RELEASE AND
            FOREVER WAIVE ANY AND ALL CLAIMS YOU MAY HAVE AGAINST THE
            WEALTHCENTRAL GROUP (INCLUDING BUT NOT LIMITED TO CLAIMS BASED UPON
            THE NEGLIGENCE OF ANY OF THE WEALTHCENTRAL GROUP) FOR LOSSES OR
            DAMAGES YOU SUSTAIN IN CONNECTION WITH YOUR USE OF THE SERVICE.
          </p>
          <p>
            NOTWITHSTANDING THE FOREGOING PARAGRAPH, THE TOTAL LIABILITY OF THE
            WEALTHCENTRAL GROUP, IF ANY, FOR LOSSES OR DAMAGES SUSTAINED BY YOU
            SHALL NOT EXCEED THE LESSER OF: (A) THE AGGREGATE OF SUBSCRIPTION
            FEES PAID BY YOU OR ON YOUR BEHALF FOR THE CALENDAR YEAR IMMEDIATELY
            PRECEDING THE DATE WHEN LIABILITY AROSE; OR (B) ONE HUNDRED DOLLARS
            ($100.00) (USD). IN NO EVENT SHALL THE WEALTHCENTRAL GROUP BE LIABLE
            TO YOU FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL,
            EXEMPLARY OR PUNITIVE DAMAGES ARISING FROM ANY USE OF THIS SITE, THE
            SERVICE OR THE CONTENT (INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR
            LOSS OF BUSINESS, LOSS OF PROFITS OR INVESTMENT, OR THE LIKE),
            WHETHER BASED ON BREACH OF CONTRACT, BREACH OF WARRANTY, TORT
            (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF WE
            HAD BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p>
            The availability of the Service depends on many factors, including
            your connection to the Internet, the availability of the Internet
            and the Internet backbone and equipment that, by its nature, is not
            fault tolerant. WealthCentral and Engage shall not be responsible
            for your inability to access the Service, or data or output errors
            (1) caused by factors outside of WealthCentral’s reasonable control;
            (2) that resulted from your or any third party’s actions or
            inaction; (3) that resulted from your equipment and/or third party
            equipment not within WealthCentral’s sole control; or (4)
            connections to the internet which are not within WealthCentral’s
            sole control.
          </p>
          <p>
            THE SERVICE DOES NOT RECOMMEND, GUARANTEE OR REPRESENT THAT FUTURE
            PERFORMANCE OF INVESTMENT OR INSURANCE PRODUCTS OF ANY KIND CAN BE
            PREDICTED. FORECASTS OF INVESTMENT DECISIONS ARE PROVIDED MERELY FOR
            INFORMATION PURPOSES AND FOR YOUR CONVENIENCE AND SHOULD NOT BE
            REGARDED AS A PREDICTION OR GUARANTEE OF ANY FUTURE RESULTS. The
            projected returns, standard deviations, and correlations included in
            the Service are based on a combination of the historical performance
            of an appropriate broad market index, as well as user-defined
            portfolio model allocations. The returns, standard deviations,
            correlation, and dividend yields are provided “AS IS,” and as a
            convenience to you. Certain other assumptions, such as tax rates and
            inflation rates may also have default values as a convenience to
            you. Such research, assumptions, and conditions might or might not
            occur in the future. WealthCentral neither warrants nor guarantees
            any of the research, assumptions, or conditions; nor does
            WealthCentral warrant or guarantee their usefulness, and the use of
            any projected data is at your own risk. You bear all responsibility
            for the results generated through the use of such data.
            WealthCentral shall not have any liability of any kind whatsoever to
            you, or to any party, because of your use of such data.
          </p>
          <p>
            To the maximum extent permitted by applicable law, under no
            circumstances shall the WealthCentral Group be liable for any
            indirect, special, incidental, consequential, or exemplary damages
            arising out of or in any way relating to the Terms of Use or that
            result from the use of, or inability to use, the Site and/or
            Service, including without limitation, loss of goodwill, work
            stoppage, lost profits, loss of data, computer failure or
            malfunction, or any and all other commercial damages or losses, even
            if advised of the possibility thereof, and regardless of the legal
            or equitable theory (contract, tort or otherwise) upon which the
            claim is based.
          </p>
          <p>
            Some states do not allow the exclusion of damages or limitation of
            liability as set forth above, so this limitation of liability may
            not apply to you. If any part of this limitation does not apply or
            is deemed to be invalid or unenforceable, for any reason, then under
            those circumstances, the aggregate liability and damage exclusion
            shall only be restricted or diminished to the extent necessary to be
            legally enforceable. If any remedy hereunder is determined to have
            failed of its essential purpose; all limitations of liability,
            disclaimers of liability, and exclusions of liability shall remain
            in effect. The limitations of damages and exclusions of liability
            set forth above are fundamental elements of the basis of the bargain
            between you and us and we would not be able to have provided you the
            Service at the prescribed Subscription rates without such
            limitations.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            13. INDEMNITY
          </Typography>
          <p>
            You agree, at your own expense, to indemnify, defend and hold
            harmless the WealthCentral Group from and against any and all
            claims, damages, liabilities, costs, and expenses, including
            reasonable attorneys’ and experts’ fees, arising out of or in
            connection with the Service, or any links on the Service, including,
            but not limited to: (1) your use of the Service; (2) use of the
            Service by someone using your account; (3) a violation of these
            Terms of Use by you or anyone using your computer (or account, where
            applicable); (4) a claim that any use of the Service by you or
            someone using your computer (or account, where applicable) (a)
            infringes any intellectual property right of any third party, (b)
            violates any right of privacy or publicity, or (c) engages in
            activity that is libelous or defamatory, or otherwise results in
            injury or damage to any third party; (5) any deletions, additions,
            insertions or alterations to, or any unauthorized use of the Service
            by you or someone using your computer (or account, where
            applicable); (6) any misrepresentation or breach of representation
            or warranty made by you contained herein; (7) any breach of any
            covenant or agreement to be performed by you hereunder; or (8) any
            claim by your Clients for losses directly caused by you and your use
            of the Content, Service and Site. You agree to pay any and all
            costs, damages, and expenses, including, but not limited to,
            reasonable attorneys’ fees and costs awarded against or otherwise
            incurred by or in connection with or arising from any such claim,
            suit, action, or proceeding attributable to any such claim. We
            reserve the right, at our own expense, to assume the exclusive
            defense and control of any matter otherwise subject to
            indemnification by you, in which event you will fully cooperate with
            us in asserting any available defense. You acknowledge and agree to
            pay reasonable attorneys’ fees incurred by us in connection with any
            and all lawsuits brought against you by the WealthCentral Group
            under this Subscription Agreement and Terms of Use, including
            without limitation, lawsuits arising from your failure to indemnify
            us pursuant to this Subscription Agreement.
          </p>
          <Typography component={"h2"} variant={"h2"}>
            14. TERMINATION
          </Typography>
          <p>
            <b>(a) Termination by Us.</b> We may change or discontinue the
            Service or the Site at any time without prior notice. You agree
            that, without notice, we may terminate this Subscription Agreement,
            or suspend your access to the Site and/or Service, with or without
            cause at any time and effective immediately. We may terminate your
            account and access to the Service and Site immediately without
            notice from us if you, in our sole discretion, fail to comply with
            any provision of these Terms of Use.
          </p>
          <p>
            <b>(b) Effect of Termination.</b> Upon termination of your
            subscription by WealthCentral, you will immediately cease access to
            the Service and destroy promptly all materials obtained from the
            Service and any copies thereof. WealthCentral shall not be liable to
            you or any third party for the termination or suspension of the
            Service, or any claims related to the termination or suspension of
            the Service.
          </p>
          <p>
            <b>(c) Survival.</b> In addition to any provisions of this
            Subscription Agreement that survive in accordance with their terms,
            the following Sections will survive any termination of this
            Agreement: Sections 1, 2(b), 3(g)- (l), 4, 6-13, 14(c), 15 and this
            Section 14(d).
          </p>
          <Typography component={"h2"} variant={"h2"}>
            15. MISCELLANEOUS
          </Typography>
          <p>
            <b>(a) Entire Agreement.</b> This Subscription Agreement (including
            the Terms of Use) constitutes the entire agreement between us with
            respect to your use of the Service and/or the Site and supersedes
            all representations, agreements and other communications regarding
            your rights to use the Service. You also may be subject to
            additional terms and conditions that may apply when you use
            affiliate services, third- party content, or third-party software.
          </p>
          <p>
            <b>(b) Amendments.</b> Only WealthCentral can amend this
            Subscription Agreement (including the Terms of Use) by posting such
            amendments on the Site, and no employee or agent of WealthCentral
            has the authority to vary this Agreement. It is your sole
            responsibility to check the Site from time to time to view such
            changes in the Subscription Agreement. If you do not agree to any of
            the changes, if and when such changes are made, you must cease using
            of the Service. Your continued use of the Service after any
            amendments to this Subscription Agreement indicates that you agree
            to such amendments.
          </p>
          <p>
            <b>(c) Severability.</b> If any provision of this Subscription
            Agreement is found by a court of competent jurisdiction to be
            invalid, illegal or unenforceable, that provision shall be construed
            in a manner consistent with applicable law to reflect as nearly as
            possible our original intent, and the remaining portions shall
            remain in full force and effect. WealthCentral also reserves the
            right, in its sole option, to terminate this Subscription Agreement
            if any provision of this Subscription Agreement is found by a court
            of competent jurisdiction to be invalid, illegal or unenforceable.
          </p>
          <p>
            <b>(d) Governing Law;</b> Jurisdiction. This Subscription Agreement
            will be governed solely by the internal laws of the State of
            Delaware without reference to its principles of conflicts of law.
            The 1980 United Nations Convention on Contracts for the
            International Sale of Goods and its related instruments will not
            apply to this Subscription Agreement. You expressly agree that
            exclusive jurisdiction for any claim or dispute with us or relating
            in any way to your use of the Service or the Site shall be in the
            state federal courts in within the U.S. federal Eastern District of
            Virginia, Alexandria division (and the courts of appeal thereof),
            and expressly consent to the personal jurisdiction of such courts.
          </p>
          <p>
            <b>(e) Waiver of Jury Trial.</b> YOU HEREBY IRREVOCABLY WAIVE ANY
            AND ALL RIGHTS TO TRIAL BY JURY IN ANY LEGAL PROCEEDING ARISING OUT
            OF OR RELATED TO THIS AGREEMENT OR YOUR USE OF THE SERVICE OR THE
            SITE.
          </p>
          <p>
            <b>(f) Relationship of the Parties.</b> You and we are independent
            contractors and this Subscription Agreement does not create any
            joint venture, employment, agency or partnership relationship.
          </p>
          <p>
            <b>(g) Notices.</b> We may deliver notice to you under this
            Agreement by means of electronic mail, a general notice on the Site,
            or by written communication delivered by first class U. S. mail to
            your address on record in your account information, if any. Such
            notices shall become effective immediately. You may give notice to
            us at any time by letter delivered by first class postage prepaid
            U.S. mail or overnight courier to the following address:
            WealthCentral Inc, 1707 L Street, NW, Suite 400 Washington DC 20036.
          </p>
          <p>
            <b>(h) Commercial Software Notice.</b> The Service and its related
            documentation are "Commercial Items," as that term is defined at 48
            C.F.R. §2.101, consisting of "Commercial Computer Software" and
            "Commercial Computer Software Documentation," as such terms are used
            in 48 C.F.R. §12.212 or 48 C.F.R. §227.7202, as applicable.
            Consistent with 48 C.F.R. §12.212 or 48 C.F.R. §227.7202-1 through
            227.7202-4, as applicable, to the extent any Commercial Computer
            Software and Commercial Computer Software Documentation are licensed
            to U.S. Government end users, the Commercial Computer Software and
            Commercial Computer Software Documentation are being licensed (a)
            only as Commercial Items and (b) with only those rights as are
            granted to all other end users pursuant to the terms and conditions
            herein. Unpublished-rights are reserved under the copyright laws of
            the United States.
          </p>
          <p>
            <b>(i) Disclosure.</b> WealthCentral reserves the right to take
            steps WealthCentral believes are reasonably necessary or appropriate
            to enforce and/or verify compliance with any part of this Agreement.
            You agree that subject to its obligations under applicable law,
            WealthCentral has the right, without liability to you, to disclose
            any account information and/or Client Information to law enforcement
            authorities, government officials, and/or third parties, as
            WealthCentral believes is reasonably necessary or appropriate to
            enforce and/or verify compliance with any part of this Agreement or
            to comply with applicable law or contractual obligations (including,
            but not limited to, WealthCentral’s right to cooperate with any
            legal process relating to your use of the Services or its
            obligations to financial institutions who have the right to verify
            that we are using your data in accordance with the terms of their
            distribution terms). We will take measures that we believe are
            commercially reasonable to protect the confidentiality of your
            information and Client Information.
          </p>
          <p>
            <b>(j) Assignment.</b> You may not assign this Agreement without our
            consent. We may assign our rights under this Agreement, in whole or
            in part, to any person without notice to you.
          </p>
          <p>
            <b>(k) No third-party beneficiaries.</b> This Agreement does not
            create any third-party beneficiary rights in any individual or
            entity that is not a party to this Agreement.
          </p>
        </div>
      </Grid>
    </Grid>
  );
};

export default TermsAndConditions;
